import { configureStore } from '@reduxjs/toolkit'
import homeReducer from '../home/reducer'
import searchReducer from '../search/reducer'
import vbReducer from '../vb/reducer'
import clientSettingReducer from '../clientSetting/reducer'
import appReducer from './reducer'
import { loadState, saveState } from '../localStorage/localStorage'

const persistedState = loadState()

export const store = (preloadedState = persistedState) =>
  configureStore({
    reducer: {
      home: homeReducer,
      search: searchReducer,
      vb: vbReducer,
      app: appReducer,
      clientSetting: clientSettingReducer,
    },
    preloadedState,
  })

const activatedStore = store()
activatedStore.subscribe(() => {
  saveState({})
})

export default activatedStore
